import {
  getChildrenUserGroups,
  getRootUserGroups,
  changeParentUserGroup,
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
} from '@/api/usergroupserv'

export default {
  state: {
    state_UserGroup_GetChildrenUserGroupsResult: null,
    state_UserGroup_GetRootUserGroupsResult: null,
    state_UserGroup_ChangeParentUserGroupResult: null,
    state_UserGroup_GetAllResult: null,
    state_UserGroup_SearchByNameResult: null,
    state_UserGroup_GetPageResult: null,
    state_UserGroup_GetDetailResult: null,
    state_UserGroup_AddObjResult: null,
    state_UserGroup_ModifyObjResult: null,
    state_UserGroup_DeleteObjResult: null,
  },
  mutations: {
    SET_USERGROUP_GETCHILDRENUSERGROUPS_RESULT: (state, rst) => {
      state.state_UserGroup_GetChildrenUserGroupsResult = rst;
    },
    SET_USERGROUP_GETROOTUSERGROUPS_RESULT: (state, rst) => {
      state.state_UserGroup_GetRootUserGroupsResult = rst;
    },
    SET_USERGROUP_CHANGEPARENTUSERGROUP_RESULT: (state, rst) => {
      state.state_UserGroup_ChangeParentUserGroupResult = rst;
    },
    SET_USERGROUP_GETALL_RESULT: (state, rst) => {
      state.state_UserGroup_GetAllResult = rst;
    },
    SET_USERGROUP_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_UserGroup_SearchByNameResult = rst;
    },
    SET_USERGROUP_GETPAGE_RESULT: (state, rst) => {
      state.state_UserGroup_GetPageResult = rst;
    },
    SET_USERGROUP_GETDETAIL_RESULT: (state, rst) => {
      state.state_UserGroup_GetDetailResult = rst;
    },
    SET_USERGROUP_ADDOBJ_RESULT: (state, rst) => {
      state.state_UserGroup_AddObjResult = rst;
    },
    SET_USERGROUP_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_UserGroup_ModifyObjResult = rst;
    },
    SET_USERGROUP_DELETEOBJ_RESULT: (state, rst) => {
      state.state_UserGroup_DeleteObjResult = rst;
    },
  },
  actions: {
    UserGroupServ_GetChildrenUserGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getChildrenUserGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_GETCHILDRENUSERGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_GETCHILDRENUSERGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_GetRootUserGroups({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getRootUserGroups(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_GETROOTUSERGROUPS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_GETROOTUSERGROUPS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_ChangeParentUserGroup({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeParentUserGroup(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_CHANGEPARENTUSERGROUP_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_CHANGEPARENTUSERGROUP_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    UserGroupServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_USERGROUP_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_USERGROUP_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_UserGroup_GetChildrenUserGroupsResult: state => {
      return state.state_UserGroup_GetChildrenUserGroupsResult;
    },
    get_UserGroup_GetRootUserGroupsResult: state => {
      return state.state_UserGroup_GetRootUserGroupsResult;
    },
    get_UserGroup_ChangeParentUserGroupResult: state => {
      return state.state_UserGroup_ChangeParentUserGroupResult;
    },
    get_UserGroup_GetAllResult: state => {
      return state.state_UserGroup_GetAllResult;
    },
    get_UserGroup_SearchByNameResult: state => {
      return state.state_UserGroup_SearchByNameResult;
    },
    get_UserGroup_GetPageResult: state => {
      return state.state_UserGroup_GetPageResult;
    },
    get_UserGroup_GetDetailResult: state => {
      return state.state_UserGroup_GetDetailResult;
    },
    get_UserGroup_AddObjResult: state => {
      return state.state_UserGroup_AddObjResult;
    },
    get_UserGroup_ModifyObjResult: state => {
      return state.state_UserGroup_ModifyObjResult;
    },
    get_UserGroup_DeleteObjResult: state => {
      return state.state_UserGroup_DeleteObjResult;
    },
  }
}